import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";

import { getTieredPartnerCalendar } from "@/lib/calendar.functions";
import { PartnerMonthCalendar } from "@/components/partner/PartnerMonthCalendar";
import { AppHeader } from "@/components/site/AppHeader";
import { PageShell } from "@/components/ui/shields-layout";

export const Route = createFileRoute("/_authenticated/partner/business/calendar")({
  head: () => ({ meta: [
    { title: "Partner calendar — Shields" },
    { name: "description", content: "Plan Shields jobs, time and team work from one calendar." },
    { name: "robots", content: "noindex" },
  ] }),
  component: PartnerCalendarPage,
});

function PartnerCalendarPage() {
  // Keep this data fetch inside the mounted React tree rather than suspending the
  // TanStack route. Lovable's preview runtime can otherwise hit React's null
  // dispatcher while the router renders its internal Await boundary.
  const { data, isPending, error, refetch } = useQuery({
    queryKey: ["partner-calendar"],
    queryFn: () => getTieredPartnerCalendar(),
    retry: 1,
  });

  return (
    <div className="min-h-screen bg-background pb-24">
      <AppHeader workspace="partner" />
      <PageShell width="standard" className="partner-calendar-ref-main">
        {isPending ? <section className="partner-calendar-ref-state">Loading your calendar…</section> : error || !data ? <section className="partner-calendar-ref-state"><strong>Calendar could not load</strong><p>Try again. No jobs or diary entries have been changed.</p><button type="button" onClick={() => refetch()} className="btn-secondary-hero mt-4">Try again</button></section> : <PartnerMonthCalendar jobs={(data.bookings ?? []) as any} hasPro={data.features.advancedCalendar} hasBusiness={data.features.teamPlanning} />}
      </PageShell>
    </div>
  );
}

